import { ProjectDocuments } from "@/pages/project/ProjectDocuments";
import { parseDocuments } from "@/pages/project/project-plan";
import { ListingRequirements } from "./ListingRequirements";
import { CommonFacetView } from "@/pages/project/CommonFacetView";
import type { FacetViewProps } from "@/pages/project/dashboard-kinds";
import { ListingApplicationsFacet, ListingApplicationsNoAccess } from "./ListingApplicationsFacet";
import { ListingImagesFacet } from "./ListingImagesFacet";
import { ListingMatchFacet } from "./ListingMatchFacet";
import { ListingTeamFacet } from "./ListingTeamFacet";

// Die Flächen eines Projekts der Art LISTING. Anforderungen und Aktivität teilt es mit jedem Projekt
// (CommonFacetView); Bilder, Team mit Stufen je Bereich, Matches ohne Gefragte und Bewerbungen hat nur
// die Ausschreibung.
export function ListingFacetView({ facet, ctx, view, onViewChange }: FacetViewProps) {
  switch (facet) {
    case "dokumente":
      return <ProjectDocuments documents={parseDocuments(ctx.data.documents)} readOnly={ctx.readOnly}
        onChange={(documents) => { ctx.editData({ documents }); ctx.keepFacets(["dokumente"]); }} />;
    case "team":
      return <ListingRequirements ctx={ctx} />;
    case "bilder":
      return (
        <ListingImagesFacet
          listingId={ctx.entity.id}
          readOnly={ctx.readOnly}
          onSaved={() => ctx.keepFacets(["bilder"])}
        />
      );
    case "mitglieder":
      return <ListingTeamFacet listingId={ctx.entity.id} />;
    case "kandidaten":
      return <ListingMatchFacet ctx={ctx} view={view} onViewChange={onViewChange} />;
    case "bewerbungen":
      // Kein Zugriff ist nicht "keine Bewerbungen": ohne Leserecht fragt die Fläche nichts ab und sagt das.
      return ctx.entity.actions.canReadApplications
        ? <ListingApplicationsFacet listingId={ctx.entity.id} />
        : <ListingApplicationsNoAccess />;
    default:
      return <CommonFacetView facet={facet} ctx={ctx} />;
  }
}
